import { request } from "../client";

import type {
  LearningHome,
  PracticeActivityInput,
  PracticeAssessment,
  PracticeMemory,
} from "@lingoshade/domain";

export function createLearningEndpoints(baseUrl: string): {
  home: (token?: string | null, timeZone?: string) => Promise<LearningHome>;
  memory: (textId: string, token?: string | null) => Promise<PracticeMemory>;
  record: (
    input: PracticeActivityInput,
    token?: string | null,
  ) => Promise<PracticeMemory>;
  goal: (days: number | null, token?: string | null) => Promise<void>;
  assess: (
    textId: string,
    assessment: PracticeAssessment,
    token?: string | null,
  ) => Promise<void>;
} {
  return {
    home: (token, timeZone = "UTC"): Promise<LearningHome> =>
      request(
        baseUrl,
        `/learning/home?timeZone=${encodeURIComponent(timeZone)}`,
        { token },
      ),
    memory: (textId, token): Promise<PracticeMemory> =>
      request(baseUrl, `/learning/texts/${encodeURIComponent(textId)}`, {
        token,
      }),
    record: (body, token): Promise<PracticeMemory> =>
      request(baseUrl, "/learning/activity", {
        method: "POST",
        body,
        token,
        keepalive: true,
      }),
    goal: (days, token): Promise<void> =>
      request(baseUrl, "/learning/goal", {
        method: "PATCH",
        body: { days },
        token,
      }),
    assess: (textId, assessment, token): Promise<void> =>
      request(baseUrl, `/learning/texts/${encodeURIComponent(textId)}`, {
        method: "PATCH",
        body: { assessment },
        token,
      }),
  };
}
